// Elias Auto Hub vehicle fitment data.
// Structure: Make -> Model -> Years. Product tags must use matching Make, Model, and Year values for Shopify filtering.
// Generated from a cleaned public reference structure and normalized for this Shopify theme.
let makeObject = {
  "Alfa Romeo": {
    "145": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001"
    ],
    "146": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001"
    ],
    "147": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "155": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998"
    ],
    "156": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003"
    ],
    "159": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "164": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998"
    ],
    "166": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003"
    ],
    "4C": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "8C": [
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "33-75": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993"
    ],
    "147 Facelift": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "156 2 Facelift": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "166 Facelift": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "Alfetta GT": [
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985"
    ],
    "Brera": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Giulia": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Giulietta": [
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Gt": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Mito": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Montreal": [
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977"
    ],
    "RZ-SZ": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993"
    ],
    "Spider": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Spider - Gtv": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "Spider Duetto": [
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994"
    ],
    "Stelvio": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Tonale": [
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ]
  },
  "Audi": {
    "A1 8X": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "A1 8X Facelift": [
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "A1 GB": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "A2": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "A3 8L": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000"
    ],
    "A3 8L Facelift": [
      "2001",
      "2002",
      "2003"
    ],
    "A3 8P-8PA": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008"
    ],
    "A3 8P-8PA Facelift": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "A3 8V": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "A3 8V Facelift": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020"
    ],
    "A3 8Y": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "A4 Allroad B8": [
      "2009",
      "2010",
      "2011"
    ],
    "A4 Allroad B8 Restyling": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "A4 Allroad B9": [
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "A4 Allroad B9 Facelift": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024"
    ],
    "A4 B5": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999"
    ],
    "A4 B5 Facelift": [
      "1999",
      "2000"
    ],
    "A4 B6": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004"
    ],
    "A4 B7": [
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "A4 B8": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "A4 B8 Facelift": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "A4 B9": [
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "A4 B9 Facelift": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024"
    ],
    "A5 8T3": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "A5 8T3 Facelift": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "A5 8W6": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020"
    ],
    "A5 8W6 Facelift": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "A6 Allroad C5": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "A6 Allroad C6": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "A6 Allroad C7": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "A6 Allroad C8": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "A6 C4": [
      "1994",
      "1995",
      "1996",
      "1997"
    ],
    "A6 C5": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004"
    ],
    "A6 C6": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "A6 C7": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "A6 C8": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "A7 C7": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "A7 C8": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "A8 D2-4D": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002"
    ],
    "A8 D3-4E": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "A8 D4-4H": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "A8 D5 Facelift": [
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "A8 D5-4N": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022"
    ],
    "Cabriolet": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000"
    ],
    "Coupe B2": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987"
    ],
    "Coupe B3": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996"
    ],
    "DKW Munga": [
      "1956",
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968"
    ],
    "e-tron": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "e-tron GT": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Q2": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020"
    ],
    "Q2 Facelift": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Q3 8U": [
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Q3 8U Facelift": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Q3 F3": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Q4 FZ": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Q5 8R": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "Q5 FY": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020"
    ],
    "Q5 FY Facelift": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Q7 4L": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "Q7 4L Facelift": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "Q7 4M": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "Q7 4M Facelift": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Q8": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Quattro MB RR": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991"
    ],
    "Quattro WR": [
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987"
    ],
    "R8 4S": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "R8 4S Facelift": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "R8 42": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "TT 8J": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "TT 8N": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "TT FV": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ]
  },
  "Bentley": {
    "Azure 1": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "Azure 2": [
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "Brooklands Coupe": [
      "2008",
      "2009",
      "2010"
    ],
    "Continental Flying Spur": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "Continental GT 1 - GTC": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "Continental GT 2 - GTC": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Continental GT 3 - GTC": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Continental R - S - T": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003"
    ],
    "Flying Spur": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "Mulsanne": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021"
    ]
  },
  "BMW": {
    "1 Series E82-E88": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "1 Series E87-E81": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "1 Series F20 Facelift": [
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "1 Series F20-F21": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "1 Series F40": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "2 Series F22-F23": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021"
    ],
    "2 Series F44 Gran Coupe": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "2 Series F45-F46 Tourer": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021"
    ],
    "2 Series G42": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "3 Series E21": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983"
    ],
    "3 Series E30": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992"
    ],
    "3 Series E36": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000"
    ],
    "3 Series E46": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "3 Series E46 Coupe-Cabriolet": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "3 Series E90-E91": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "3 Series E92-E93": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "3 Series F30-F31": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "3 Series G20-G21": [
      "2019",
      "2020",
      "2021",
      "2022"
    ],
    "3 Series GT F34": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "4 Series F32-F33-F36": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "5 Series E12-E28": [
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981"
    ],
    "5 Series E34": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995"
    ],
    "5 Series E39": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003"
    ],
    "5 Series E60-E61": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "5 Series F10-F11": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "5 Series G30-G31": [
      "2017",
      "2018",
      "2019",
      "2020"
    ],
    "5 Series G60-G61": [
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "5 Series GT F07": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "6 Series E24": [
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989"
    ],
    "6 Series E63-E64": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "6 Series F12-F13-F06": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "6 Series GT G32": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "7 Series E23-E32": [
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994"
    ],
    "7 Series E38": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001"
    ],
    "7 Series E65-E66": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008"
    ],
    "7 Series F01-F02": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "7 Series G11-G12": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022"
    ],
    "8 Series E31": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999"
    ],
    "8 Series G15-G14-G16": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "i3": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "i3 Facelift": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "i4": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "i8": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "iX": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "iX3": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "M1 Supercar": [
      "1978",
      "1979",
      "1980",
      "1981"
    ],
    "Series 2 U06 Tourer": [
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Series 3 G20-G21 Facelift": [
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Series 4 G22-G23-G26": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Series 5 G30-G31 Facelift": [
      "2020",
      "2021",
      "2022",
      "2023"
    ],
    "Series 7 G70": [
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "X1 E84": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "X1 F48": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "X1 F48 Facelift": [
      "2019",
      "2020",
      "2021",
      "2022"
    ],
    "X1 U11": [
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "X2 F39": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "X3 E83": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "X3 F25": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "X3 F25 Facelift": [
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "X3 G01": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021"
    ],
    "X3 G01 Facelift": [
      "2021",
      "2022",
      "2023",
      "2024"
    ],
    "X3 G45": [
      "2024",
      "2025",
      "2026"
    ],
    "X4 F26": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "X4 G02": [
      "2018",
      "2019",
      "2020",
      "2021"
    ],
    "X4 G02 Facelift": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "X5 E53": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003"
    ],
    "X5 E53 Facelift": [
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "X5 E70": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "X5 F15-F85": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "X5 G05": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "X6 E71-E72": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "X6 F16-F86": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "X6 G06": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "X7 G07": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022"
    ],
    "X7 G07 Facelift": [
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Z1": [
      "1988",
      "1989",
      "1990",
      "1991"
    ],
    "Z3 E36": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002"
    ],
    "Z4 E85-E86": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008"
    ],
    "Z4 E89": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "Z4 G29": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Z8 E52": [
      "2000",
      "2001",
      "2002",
      "2003"
    ]
  },
  "Chevrolet": {
    "Avalanche I": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "Avalanche II": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "Aveo T250": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "Aveo T300": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Blazer": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "Camaro III": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992"
    ],
    "Camaro IV": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002"
    ],
    "Camaro V": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "Camaro VI": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Captiva": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Captiva Facelift": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "Chevelle": [
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977"
    ],
    "Colorado I": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "Colorado II": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Corvette C1": [
      "1953",
      "1954",
      "1955",
      "1956",
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962"
    ],
    "Corvette C2": [
      "1963",
      "1964",
      "1965",
      "1966",
      "1967"
    ],
    "Corvette C3": [
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982"
    ],
    "Corvette C4": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996"
    ],
    "Corvette C5": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004"
    ],
    "Corvette C6": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "Corvette C7": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021"
    ],
    "Corvette C8": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Cruze": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "Epica": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "Kalos": [
      "2005",
      "2006",
      "2007",
      "2008"
    ],
    "Lacetti": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "Malibu IX": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Malibu VIII": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "Matiz": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Orlando": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Silverado I": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "Silverado II": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Spark": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Trax": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ]
  },
  "Chrysler": {
    "300C": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "300C II": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023"
    ],
    "300M": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004"
    ],
    "Crossfire": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008"
    ],
    "Grand Voyager V": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "PT Cruiser": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Sebring I": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000"
    ],
    "Sebring II": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "Sebring III": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Voyager I": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990"
    ],
    "Voyager II": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995"
    ],
    "Voyager III": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000"
    ],
    "Voyager IV": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008"
    ]
  },
  "Citroen": {
    "Berlingo I": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003"
    ],
    "Berlingo I Facelift": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "Berlingo II": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Berlingo III": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "C-Crosser": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "C-Elysee": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "C-Elysee Facelift": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "C-Zero": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "C1 I": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "C1 II": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "C2": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "C3 Aircross": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021"
    ],
    "C3 Aircross Facelift": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "C3 Facelift": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "C3 I": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "C3 II": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "C3 III": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020"
    ],
    "C3 Picasso": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "C3 Pluriel": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "C4 Aircross": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "C4 Cactus": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "C4 Cactus Facelift": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "C4 I": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "C4 II": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "C4 III": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "C4 Picasso I - Grand": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "C4 Picasso II - Grand": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "C4 Spacetourer": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "C4 X": [
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "C5 Aircross": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "C5 I": [
      "2001",
      "2002",
      "2003",
      "2004"
    ],
    "C5 I Facelift": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008"
    ],
    "C5 II": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "C5 X": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "C6": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "C8": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "DS Pallas": [
      "1955",
      "1956",
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975"
    ],
    "DS3": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "DS4 I": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "DS4 II": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "DS5": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "DS7": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "DS9": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Dyane": [
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984"
    ],
    "e-mehari": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Jumper I": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "Jumper II": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Jumper III": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Jumpy I": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004"
    ],
    "Jumpy I Facelift": [
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "Jumpy II": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "Jumpy III": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Nemo": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "Saxo": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004"
    ],
    "Spacetourer": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Xsara": [
      "1997",
      "1998",
      "1999",
      "2000"
    ],
    "Xsara Facelift": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004"
    ],
    "Xsara Picasso": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ]
  },
  "Cupra": {
    "Ateca": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Born": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Formentor": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Leon": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ]
  },
  "Dacia": {
    "Dokker": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021"
    ],
    "Duster I": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "Duster II": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Jogger": [
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Lodgy": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022"
    ],
    "Logan I": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "Logan II": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "Logan II Facelift": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Sandero I - Stepway": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "Sandero II - Stepway": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "Sandero II - Stepway Facelift": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020"
    ],
    "Sandero III": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Spring": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ]
  },
  "Daewoo": {
    "Kalos": [
      "2002",
      "2003",
      "2004"
    ],
    "Lacetti": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "Matiz I": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "Matiz II": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ]
  },
  "Dodge": {
    "Avenger II": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "Caliber": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "Challenger I": [
      "1970",
      "1971",
      "1972",
      "1973",
      "1974"
    ],
    "Challenger III": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Charger III - LX": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Charger IV - LD": [
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Charger IV - LD Facelift": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Durango I": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003"
    ],
    "Durango II": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "Durango III": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Durango III Facelift": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Journey": [
      "2008",
      "2009",
      "2010"
    ],
    "Magnum II": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008"
    ],
    "Nitro": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "Ram I": [
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993"
    ],
    "Ram II": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001"
    ],
    "Ram III": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "Ram IV": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Ram V": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Viper": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Viper RT-10 GTS": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002"
    ],
    "Viper SRT-10": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ]
  },
  "DR EVO": {
    "DR 1": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "DR 2": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "DR 3-DR 3.0": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "DR 4-EVO 4": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "DR 4.0": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "DR 5-EVO 5": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022"
    ],
    "DR 5.0": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "DR 6- EVO 6": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021"
    ],
    "DR 6.0": [
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "DR 7.0": [
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "DR City Cross": [
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "DR F35": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "DR Zero": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ]
  },
  "Ferrari": {
    "456": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003"
    ],
    "458": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "599": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "328 GTB-GTS": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989"
    ],
    "348 TB-TS": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995"
    ],
    "360 Modena": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004"
    ],
    "488 GTB": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "575-550M Maranello": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "612 Scaglietti": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "California - T": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Dino GTS": [
      "1969",
      "1970",
      "1971",
      "1972",
      "1973"
    ],
    "F12 Berlinetta": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "F355 Spider": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999"
    ],
    "F430": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "FF": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "GTC4Lusso": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Mondial": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993"
    ],
    "Testarossa": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996"
    ]
  },
  "Fiat": {
    "124": [
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "126": [
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000"
    ],
    "500": [
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "600": [
      "1955",
      "1956",
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969"
    ],
    "850": [
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971"
    ],
    "500 e": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "500 Facelift": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "500L": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "500X": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "500X Facelift": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Barchetta": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "Brava": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002"
    ],
    "Bravo I": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002"
    ],
    "Bravo II": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Campagnola": [
      "1951",
      "1952",
      "1953",
      "1954",
      "1955",
      "1956",
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987"
    ],
    "Cinquecento": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998"
    ],
    "Coupe": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000"
    ],
    "Croma 154": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991"
    ],
    "Croma 154 Facelift": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996"
    ],
    "Croma 194": [
      "2005",
      "2006",
      "2007"
    ],
    "Croma 194 Facelift": [
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Doblo I": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "Doblo II": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Ducato II": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002"
    ],
    "Ducato II Facelift": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "Ducato III": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Ducato IV": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Fiorino III": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Freemont": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Fullback": [
      "2016",
      "2017",
      "2018"
    ],
    "Grande Punto 199": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "Idea": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "Mobi": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Multipla I": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003"
    ],
    "Multipla II": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Palio": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "Panda I 141": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003"
    ],
    "Panda II 169": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "Panda II 169 Cross": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "Panda III 319": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Panda III 319 Cross": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Punto": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Punto Evo 199": [
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "Punto I 176": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999"
    ],
    "Punto I GT 176": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999"
    ],
    "Punto II 188": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003"
    ],
    "Punto II 188 Facelift": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Qubo": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Ritmo I": [
      "1978",
      "1979",
      "1980",
      "1981"
    ],
    "Ritmo II": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988"
    ],
    "Scudo I": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "Scudo II": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "Sedici": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Seicento": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Siena II": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Stilo": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Talento": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Tipo I-II": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995"
    ],
    "Tipo III": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021"
    ],
    "Tipo III Facelift": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Ulysse": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "Uno": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995"
    ],
    "X1/9": [
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989"
    ]
  },
  "Ford": {
    "B-Max": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Bronco": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "C-Max I Facelift": [
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "C-Max II": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "C-Max II Facelift": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Connect I": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "Connect II": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Courier": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Custom I": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022"
    ],
    "Custom II": [
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Ecosport II": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "Ecosport II Facelift": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Edge": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Escort IV": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000"
    ],
    "Escort RS": [
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990"
    ],
    "Fiesta III": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995"
    ],
    "Fiesta IV": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999"
    ],
    "Fiesta IV Facelift": [
      "1999",
      "2000",
      "2001",
      "2002"
    ],
    "Fiesta V": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008"
    ],
    "Fiesta VI": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "Fiesta VI Facelift": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "Fiesta VII": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021"
    ],
    "Fiesta VII Facelift": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Focus C-Max I": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "Focus I": [
      "1998",
      "1999",
      "2000",
      "2001"
    ],
    "Focus I Facelift": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "Focus II": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008"
    ],
    "Focus II Facelift": [
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "Focus III": [
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Focus III Facelift": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Focus IV": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Fusion": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "Galaxy I": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000"
    ],
    "Galaxy I Facelift": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "Galaxy II": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "Galaxy III": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020"
    ],
    "Galaxy III Facelift": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "GT": [
      "2004",
      "2005",
      "2006"
    ],
    "Ka I": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008"
    ],
    "Ka II": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "Ka+": [
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "Kuga I": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "Kuga II": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "Kuga II Facelift": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Kuga III": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Mondeo 1 MkII": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000"
    ],
    "Mondeo 2 MkIII": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "Mondeo 3 MkIV": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Mondeo 4 MkV": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022"
    ],
    "Mustang I": [
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973"
    ],
    "Mustang II": [
      "1974",
      "1975",
      "1976",
      "1977",
      "1978"
    ],
    "Mustang III": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993"
    ],
    "Mustang IV": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004"
    ],
    "Mustang Mach-E": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Mustang V": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Mustang V Facelift": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Mustang VI": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022"
    ],
    "Mustang VII": [
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Puma": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Ranger I": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "Ranger I Facelift": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "Ranger II": [
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "Ranger II Facelift T5": [
      "2009",
      "2010",
      "2011"
    ],
    "Ranger III Facelift T7": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Ranger III T6": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "Ranger Wildtrack": [
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "S-Max I": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "S-Max II": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Sierra Rs-cosworth": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992"
    ],
    "Transit VI": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "Transit VII": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Transit VIII": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ]
  },
  "Honda": {
    "Accord VII": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "Accord VIII": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "Civic IX": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "Civic V": [
      "1992",
      "1993",
      "1994",
      "1995"
    ],
    "Civic VI": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001"
    ],
    "Civic VII": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "Civic VIII": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "Civic X": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021"
    ],
    "Civic XI": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "CR-V I": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002"
    ],
    "CR-V II": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "CR-V III": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "CR-V IV": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "CR-V V": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "CR-Z": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "FR-V": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "HR-V": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "HR-V II": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "HR-V II Facelift": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Insight II": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Jazz I": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008"
    ],
    "Jazz II": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "Jazz III": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "Jazz IV": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Prelude 5": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001"
    ],
    "S2000": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004"
    ],
    "S2000 Facelift": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ]
  },
  "Hyundai": {
    "Atos": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003"
    ],
    "Atos Facelift": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008"
    ],
    "Bayon": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Coupe I": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000"
    ],
    "Coupe I Facelift": [
      "2000",
      "2001"
    ],
    "Coupe II": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "Coupe II Facelift": [
      "2007",
      "2008",
      "2009"
    ],
    "Galloper": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003"
    ],
    "Genesis coupe": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "Genesis coupe Facelift": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "Getz": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "Getz Facelift": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "H350": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "i10": [
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "i10 Facelift": [
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "i10 II": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "i10 III": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "i20": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "i20 Facelift": [
      "2012",
      "2013",
      "2014"
    ],
    "i20 II": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020"
    ],
    "i20 III": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "i30": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "i30 II": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "i30 III": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "i40": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Ioniq": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020"
    ],
    "Ioniq 5": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "ix20": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "ix35": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "Kona": [
      "2017",
      "2018",
      "2019",
      "2020"
    ],
    "Kona Electric": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Kona Facelift": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Matrix": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "Matrix Facelift": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Nexo": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Santa Fe I": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "Santa Fe II": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "Santa Fe III": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Santa Fe IV": [
      "2018",
      "2019",
      "2020"
    ],
    "Santa Fe IV Facelift": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Staria": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Terracan": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "Tucson I": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "Tucson II": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "Tucson III": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021"
    ],
    "Tucson IV": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Veloster": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ]
  },
  "Hummer": {
    "H1": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "H2": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "H3": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ]
  },
  "Infiniti": {
    "EX": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "FX I": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008"
    ],
    "FX II": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Q30": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "Q50": [
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "Q50 Facelift": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020"
    ],
    "Q60 CV36": [
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "Q60 V37": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Q70": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "QX30": [
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "QX50 I": [
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "QX50 II": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "QX70": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017"
    ]
  },
  "Isuzu": {
    "D-Max I": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "D-Max I Facelift": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "D-Max II": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "D-Max II Facelift": [
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "D-Max III": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Trooper": [
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002"
    ]
  },
  "Jaguar": {
    "E-Pace": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "E-Type": [
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975"
    ],
    "F-Pace": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "F-Type": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "F-Type Facelift": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "I-Pace": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "S-Type": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008"
    ],
    "X-Type": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "XE": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "XE Facelift": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "XF I": [
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "XF I Facelift": [
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "XF II": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "XJ-S": [
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996"
    ],
    "XJ-X300": [
      "1994",
      "1995",
      "1996",
      "1997"
    ],
    "XJ-X308": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003"
    ],
    "XJ-X350-X358": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "XJ-X351": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "XK I": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "XK II": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ]
  },
  "Jeep": {
    "Cherokee KJ": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008"
    ],
    "Cherokee KK": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "Cherokee KL": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "Cherokee KL Facelift": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Cherokee XJ": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001"
    ],
    "Commander XH": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Compass I": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "Compass I Facelift": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "Compass II": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021"
    ],
    "Compass II Facelift": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Gladiator": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Grand Cherokee WJ": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004"
    ],
    "Grand Cherokee WK-WH": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Grand Cherokee WK2": [
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "Grand Cherokee WK2 Facelift": [
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "Grand Cherokee WK2 Facelift 2": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021"
    ],
    "Grand Cherokee WL": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Grand Cherokee ZJ-ZG": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998"
    ],
    "Patriot": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Renegade": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Renegade Facelift": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Wrangler JK": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Wrangler JL": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Wrangler TJ": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "Wrangler YJ": [
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997"
    ]
  },
  "Kia": {
    "Carens I-II": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "Carens III": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "Carens IV": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Carnival I": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "Carnival II": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Cee'd - Pro Cee' d II JD": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Cee'd - Pro Cee'd I ED": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "Ceed - Pro Ceed III CD": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Cerato I": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "EV6": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Niro DE": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022"
    ],
    "Niro SG2": [
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Optima III": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "Optima IV": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Picanto I": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "Picanto I Facelift": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "Picanto II": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "Picanto III": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Rio I": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "Rio II": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "Rio III": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "Rio IV": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Sorento I BL": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "Sorento II Facelift": [
      "2012",
      "2013",
      "2014"
    ],
    "Sorento II XM": [
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "Sorento III UM": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020"
    ],
    "Sorento IV MQ4": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Soul I": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "Soul I Facelift": [
      "2012",
      "2013",
      "2014"
    ],
    "Soul II": [
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "Soul II Facelift": [
      "2017",
      "2018",
      "2019",
      "2020"
    ],
    "Soul III": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Sportage I": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002"
    ],
    "Sportage II": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008"
    ],
    "Sportage II Facelift": [
      "2008",
      "2009",
      "2010"
    ],
    "Sportage III": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "Sportage IV": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021"
    ],
    "Sportage V": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Stonic": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Venga": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "Xceed": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ]
  },
  "Lada": {
    "Niva": [
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993"
    ],
    "Niva Bronto": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Niva Facelift": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Niva Urban": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ]
  },
  "Lamborghini": {
    "Aventador": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Diablo V": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001"
    ],
    "Espada": [
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978"
    ],
    "Gallardo": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "Huracan": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Miura": [
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973"
    ],
    "Murcielago": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Reventon": [
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Urus": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Veneno": [
      "2013",
      "2014"
    ]
  },
  "Lancia": {
    "Dedra": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999"
    ],
    "Delta I": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993"
    ],
    "Delta II": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999"
    ],
    "Delta III": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Flavia": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "K": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001"
    ],
    "Lybra": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "Musa": [
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "Musa Facelift": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "Phedra": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008"
    ],
    "Phedra Facelift": [
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "Prisma": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986"
    ],
    "Prisma II": [
      "1986",
      "1987",
      "1988",
      "1989"
    ],
    "Thema": [
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Thema I-II": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994"
    ],
    "Thesis": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "Voyager": [
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Y": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003"
    ],
    "Y10": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989"
    ],
    "Y10 II": [
      "1989",
      "1990",
      "1991",
      "1992"
    ],
    "Y10 III": [
      "1992",
      "1993",
      "1994",
      "1995"
    ],
    "Ypsilon I": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "Ypsilon II": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ]
  },
  "Land Rover": {
    "Defender": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Defender 90 - 110": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990"
    ],
    "Discovery I": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998"
    ],
    "Discovery II": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004"
    ],
    "Discovery III": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "Discovery IV": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "Discovery Sport": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "Discovery Sport Facelift": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Discovery V": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Evoque": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "Evoque 2": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Evoque Facelift": [
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Freelander I": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004"
    ],
    "Freelander I Facelift": [
      "2004",
      "2005",
      "2006"
    ],
    "Freelander II": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "Freelander II Facelift": [
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "New Defender": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "Range Rover I": [
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996"
    ],
    "Range Rover II": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002"
    ],
    "Range Rover III": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Range Rover III Facelift": [
      "2010",
      "2011",
      "2012"
    ],
    "Range Rover IV": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021"
    ],
    "Range Rover Sport I": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Range Rover Sport I Facelift": [
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "Range Rover Sport II": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "Range Rover Sport II Facelift": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022"
    ],
    "Range Rover Sport III": [
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Range Rover V": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Velar": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ]
  },
  "Lexus": {
    "CT": [
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "CT Facelift": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "ES": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "GS III": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "GS IV": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "GS IV Facelift": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "IS II": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "IS III": [
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "IS III Facelift": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "LC 500": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "LS V": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "NX I": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021"
    ],
    "NX II": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "RC": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "RX AL10": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "RX AL20": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "RX XU10": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003"
    ],
    "RX XU30": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008"
    ],
    "SC I": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001"
    ],
    "SC II": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "UX": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ]
  },
  "Lotus": {
    "Eletre": [
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Elise I": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001"
    ],
    "Elise II": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "Elise III": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Emira": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Europa SE": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Evora": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Exige S1": [
      "2000",
      "2001",
      "2002"
    ],
    "Exige S2": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "Exige S3": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ]
  },
  "Iveco": {
    "Daily": [
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990"
    ],
    "Daily II": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000"
    ],
    "Daily III": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "Daily IV": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "Daily V": [
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Daily VI": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "Massif - Campagnola": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ]
  },
  "Maserati": {
    "3200 GT": [
      "1998",
      "1999",
      "2000",
      "2001"
    ],
    "Biturbo": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992"
    ],
    "Coupe": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "Ghibli": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Ghibli II": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997"
    ],
    "GranCabrio": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "GranTurismo": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "Grecale": [
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Levante": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "MC20": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Quattroporte III": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990"
    ],
    "Quattroporte IV": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000"
    ],
    "Quattroporte V": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "Quattroporte VI": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Spyder": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007"
    ]
  },
  "Mazda": {
    "5": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "2 DE": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "2 DJ": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022"
    ],
    "2 DY": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "2 Hybrid ZV": [
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "3 BK": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "3 BL": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "3 BM": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "3 BP": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "5 II": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "6 GG": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008"
    ],
    "6 GH": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "6 GJ": [
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "6 GJ Facelift": [
      "2015",
      "2016",
      "2017"
    ],
    "6 GL": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "BT-50": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "CX 30": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "CX-3": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "CX-5 I": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "CX-5 II": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021"
    ],
    "CX-5 II Facelift": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "CX-7": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "CX-60": [
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "DEMIO": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002"
    ],
    "MX-5 I": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998"
    ],
    "MX-5 II": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "MX-5 III": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "MX-5 IV": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "MX-30": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "RX-7": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002"
    ],
    "RX-8": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ]
  },
  "Mercedes-Benz": {
    "190": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993"
    ],
    "A Class W168": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004"
    ],
    "A Class W169": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "A Class W176": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "A Class W177": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "B Class W245": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "B Class W246": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "B Class W247": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "C Class SportCoupe CL203": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008"
    ],
    "C Class W202": [
      "1993",
      "1994",
      "1995",
      "1996"
    ],
    "C Class W202 Facelift": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000"
    ],
    "C Class W203": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "C Class W204": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "C Class W204 Facelift": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "C Class W205": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021"
    ],
    "Citan I": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021"
    ],
    "Citan II": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "CL C140": [
      "1996",
      "1997",
      "1998",
      "1999"
    ],
    "CL C215": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "CL C216": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "CL C216 Facelift": [
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "CLA W117": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "CLA W118": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Classe C W206": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Classe E W114 W115": [
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976"
    ],
    "Classe E W123": [
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985"
    ],
    "Classe E W213 Facelift": [
      "2020",
      "2021",
      "2022",
      "2023"
    ],
    "Classe E W214": [
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Classe G W460-W461": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Classe G W463": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008"
    ],
    "Classe G W463 Facelift": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "Classe G W463 Facelift II": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "Classe G W464": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Classe S W126": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991"
    ],
    "Classe S W223": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Classe X": [
      "2017",
      "2018",
      "2019",
      "2020"
    ],
    "CLC": [
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "CLK Class C208": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003"
    ],
    "CLK Class C209": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "CLS C218": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "CLS C219": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "CLS C257": [
      "2018",
      "2019",
      "2020",
      "2021"
    ],
    "CLS C257 Facelift": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "E Class Coupe C207": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "E Class Coupe Facelift C207": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "E Class Coupe W238": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "E Class W124": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997"
    ],
    "E Class W210": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003"
    ],
    "E Class W211": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "E Class W211 Facelift": [
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "E Class W212": [
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "E Class W212 Facelift": [
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "E Class W213": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020"
    ],
    "EQA": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "EQB": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "EQC": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "EQE": [
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "EQS": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "EQV - eVito": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "GL Class X164": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "GL Class X166": [
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "GLA H247": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "GLA X156": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020"
    ],
    "GLB": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "GLC X253": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022"
    ],
    "GLC X254": [
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "GLE V167": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "GLE W166": [
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "GLK": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "GLK Facelift": [
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "GLS Class X166 Facelift": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "GLS Class X167": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "ML W163": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "ML W164": [
      "2005",
      "2006",
      "2007"
    ],
    "ML W164 Facelift": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "ML W166": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "R Class W251": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "R Class W251 Facelift": [
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "S Class W140": [
      "1991",
      "1992",
      "1993",
      "1994"
    ],
    "S Class W140 Facelift": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998"
    ],
    "S Class W220": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "S Class W221": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "S Class W222": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020"
    ],
    "S Coupe C217": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "SL R107": [
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989"
    ],
    "SL R129": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001"
    ],
    "SL R230": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008"
    ],
    "SL R230 Facelift": [
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "SL R231": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020"
    ],
    "SL R232": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "SLC": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "SLK R170": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004"
    ],
    "SLK R171": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "SLK R172": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "SLS": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Sprinter W901-5": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "Sprinter W906": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "Sprinter W906 Facelift": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Sprinter W907-10": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "T1": [
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995"
    ],
    "V Class W447": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "V Class-Vito W638": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003"
    ],
    "Viano W639": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Viano W639 Facelift": [
      "2010",
      "2011",
      "2012",
      "2013"
    ]
  },
  "Mitsubishi": {
    "ASX": [
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "ASX Facelift": [
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "ASX Facelift I": [
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "ASX Facelift II": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Colt V": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002"
    ],
    "Colt VI": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008"
    ],
    "Colt VI Facelift": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "Eclipse Cross": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021"
    ],
    "Eclipse Cross Facelift": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Eclipse I": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995"
    ],
    "Eclipse II": [
      "1995",
      "1996",
      "1997"
    ],
    "Eclipse II Facelift": [
      "1997",
      "1998",
      "1999",
      "2000"
    ],
    "Eclipse III": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "Eclipse IV": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "Grandis": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "GTO": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000"
    ],
    "i-MiEV": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020"
    ],
    "L200 III": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "L200 IV": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "L200 V": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "L200 VI": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Outlander I": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "Outlander II": [
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Outlander II Facelift": [
      "2010",
      "2011",
      "2012"
    ],
    "Outlander III": [
      "2013",
      "2014",
      "2015"
    ],
    "Outlander III Facelift": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021"
    ],
    "Outlander IV": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Pajero I": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991"
    ],
    "Pajero II": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999"
    ],
    "Pajero III": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "Pajero IV": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Pajero Pinin": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "Pajero Sport I - Facelift 1": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004"
    ],
    "Pajero Sport I - Facelift 2": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008"
    ],
    "Pajero Sport II": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "Pajero Sport III": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "Pajero Sport III Facelift": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Space star I": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "Space Star II": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ]
  },
  "Mini": {
    "Clubman F54": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Clubman R55": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Countryman F60": [
      "2017",
      "2018",
      "2019",
      "2020"
    ],
    "Countryman F60 Facelift": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Countryman R60": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "Countryman R60 Facelift": [
      "2014",
      "2015",
      "2016"
    ],
    "Mini - Minor": [
      "1955",
      "1956",
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971"
    ],
    "Mini Cooper SE": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Mini I R50-R52-R53": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "Mini II R56-R57": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "Mini III F55-F56-F57": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Mini One": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Paceman R61": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "Roadster R58-R59": [
      "2012",
      "2013",
      "2014",
      "2015"
    ]
  },
  "Nissan": {
    "350Z": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "370Z": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Almera": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000"
    ],
    "Almera II": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "Almera Tino": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "Ariya": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Cube II Z11": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008"
    ],
    "Cube II Z11 restyling": [
      "2006",
      "2007",
      "2008"
    ],
    "Cube III Z12": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "GT-R R35": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "GT-R R35 Facelift": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Interstar": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "Juke": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Juke Facelift": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "Juke II": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Kubistar": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "Leaf": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "Leaf ZE1": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Micra II K11": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002"
    ],
    "Micra III K12": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Micra IV K13": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Micra IV K13 Facelift": [
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "Micra V K14": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Murano I": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "Murano II": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "Murano III": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Navara II D22": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "Navara III D40": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "Navara IV D23": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Note E11": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "Note E11 Facelift": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "Note II E12": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "Note II E12 Facelift": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "NV200": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "NV400": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Pathfinder II R50": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004"
    ],
    "Pathfinder III R51": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "Pathfinder IV R52": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Patrol GR IV Y60": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997"
    ],
    "Patrol GR V Y61": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "Patrol TR": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993"
    ],
    "Patrol VI Y62": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Pixo": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "Primastar I": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "Primastar II": [
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Primera I P10": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996"
    ],
    "Primera II P11": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001"
    ],
    "Primera III P12": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008"
    ],
    "Pulsar": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Qashqai J10": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Qashqai J10 Facelift": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Qashqai J11": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Qashqai J11 Facelift": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021"
    ],
    "Qashqai J12": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Skyline GT-R R32": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994"
    ],
    "Skyline GT-R R33": [
      "1995",
      "1996",
      "1997",
      "1998"
    ],
    "Skyline GT-R R34": [
      "1999",
      "2000",
      "2001",
      "2002"
    ],
    "Terrano": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "Townstar": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "X-Trail I T30": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "X-Trail II T31": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "X-Trail III T32": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022"
    ],
    "X-Trail IV T33": [
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ]
  },
  "Opel": {
    "Adam": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "Adam Rocks": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "Agila A": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "Agila B": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Antara": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Astra F": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002"
    ],
    "Astra H": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "Astra J": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Astra K": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021"
    ],
    "Astra L": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Atra G": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "Calibra": [
      "1994",
      "1995",
      "1996",
      "1997"
    ],
    "Cascada": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "Combo C": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "Combo D": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Combo E": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Corsa B": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000"
    ],
    "Corsa C": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "Corsa D": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Corsa D Facelift": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Corsa E": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "Corsa F": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Crossland Facelift": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Crossland X": [
      "2017",
      "2018",
      "2019",
      "2020"
    ],
    "Frontera A": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998"
    ],
    "Frontera B": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004"
    ],
    "Grandland Facelift": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Grandland X": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021"
    ],
    "GT Cabriolet": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Insignia A": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "Insignia A Facelift": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "Insignia B": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022"
    ],
    "Kadett": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994"
    ],
    "Karl": [
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Karl Rocks": [
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "Meriva A": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Meriva B": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Meriva B Facelift": [
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "Mokka A": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "Mokka B": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Mokka X": [
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "Movano A": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Movano B": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021"
    ],
    "Movano C": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Omega A": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994"
    ],
    "Omega B": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003"
    ],
    "Signum": [
      "2003",
      "2004",
      "2005"
    ],
    "Signum Facelift": [
      "2005",
      "2006",
      "2007",
      "2008"
    ],
    "Speedster": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "Tigra": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000"
    ],
    "Tigra TwinTop": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "Vectra A": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995"
    ],
    "Vectra B": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002"
    ],
    "Vectra C": [
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "Vectra C Facelift": [
      "2006",
      "2007",
      "2008"
    ],
    "Vivaro A": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Vivaro B": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "Vivaro C": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Zafira A": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "Zafira B": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Zafira Life - Crosscamp": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Zafira Tourer C": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "Zafira Tourer C Facelift": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ]
  },
  "Peugeot": {
    "107": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "108": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "205": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998"
    ],
    "206": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "207": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "208": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "306": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002"
    ],
    "307": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "308": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "406": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "407": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "408": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "607": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "806": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002"
    ],
    "807": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "1007": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "2008": [
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "4007": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "4008": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "106 I": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996"
    ],
    "106 II": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004"
    ],
    "107 Facelift II": [
      "2012",
      "2013",
      "2014"
    ],
    "206 Plus": [
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "206CC": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "207CC": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "208 II": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "307 CC": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "307 Facelift": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "308 CC": [
      "2009",
      "2010",
      "2011"
    ],
    "308 CC restyling": [
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "308 Facelift": [
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "308 II": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "308 II Facelift": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021"
    ],
    "308 III": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "406 Coupe": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "407 Coupe": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "408 II": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022"
    ],
    "408 III": [
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "508 I": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "508 I Facelift": [
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "508 II": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "508 RXH": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "508 RXH Facelift": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "2008 Facelift": [
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "2008 II": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "3008 I": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "3008 I Facelift": [
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "3008 II": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020"
    ],
    "3008 II Facelift": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "5008 I": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "5008 I Facelift": [
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "5008 II": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020"
    ],
    "5008 II Facelift": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Bipper": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Boxer I": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "Boxer II": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Boxer III": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Expert I": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004"
    ],
    "Expert I restyling": [
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "Expert II": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "Expert III": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "iOn": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "Partner I": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003"
    ],
    "Partner I Facelift": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "Partner II": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "Partner II Facelift": [
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "Partner II Facelift 2": [
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Partner III - Rifter": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "RCZ": [
      "2010",
      "2011",
      "2012"
    ],
    "RCZ Facelift": [
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "Traveller": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ]
  },
  "Porsche": {
    "911": [
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971"
    ],
    "912": [
      "1965",
      "1966",
      "1967",
      "1968",
      "1969"
    ],
    "928": [
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995"
    ],
    "959": [
      "1986",
      "1987",
      "1988"
    ],
    "968": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995"
    ],
    "718 Cayman-982": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "911 Carrera": [
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989"
    ],
    "911 Targa": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "911-964": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994"
    ],
    "911-991": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "911-992": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "911-993": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997"
    ],
    "911-996": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "911-997": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "918 Spyder": [
      "2013",
      "2014",
      "2015"
    ],
    "924-944": [
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991"
    ],
    "Boxster-718": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Boxster-981": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "Boxster-986": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004"
    ],
    "Boxster-987": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "Carrera GT": [
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "Cayenne I": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "Cayenne I Facelift": [
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Cayenne II": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Cayenne II Facelift": [
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "Cayenne III": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Cayman-981": [
      "2013",
      "2014",
      "2015"
    ],
    "Cayman-987 Mk1": [
      "2006",
      "2007",
      "2008"
    ],
    "Cayman-987 Mk2": [
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "Macan": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Macan Facelift": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Panamera": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "Panamera II": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020"
    ],
    "Panamera II Facelift": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Taycan": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ]
  },
  "Renault": {
    "Alaskan": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Arkana": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Austral": [
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Avantime": [
      "2001",
      "2002",
      "2003"
    ],
    "Captur": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "Captur Facelift": [
      "2017",
      "2018",
      "2019",
      "2020"
    ],
    "Captur II": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Clio I": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998"
    ],
    "Clio II": [
      "1998",
      "1999",
      "2000",
      "2001"
    ],
    "Clio II Facelift": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "Clio III": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "Clio III Facelift": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "Clio IV": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "Clio V": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Espace I": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991"
    ],
    "Espace II": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996"
    ],
    "Espace III": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000"
    ],
    "Espace III Facelift": [
      "2000",
      "2001",
      "2002"
    ],
    "Espace IV": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "Espace IV Facelift": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Espace V": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Express": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Fluence": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Kadjar": [
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Kadjar Facelift": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Kangoo I": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008"
    ],
    "Kangoo II": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "Kangoo II Facelift": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021"
    ],
    "Kangoo III": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Koleos": [
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "Koleos Facelift": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "Koleos II": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Laguna I": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001"
    ],
    "Laguna II": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "Laguna II Facelift": [
      "2005",
      "2006",
      "2007"
    ],
    "Laguna III": [
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Laguna III Facelift": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "Latitude": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "Master II": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Master III": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Master III Facelift": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "Master III Facelift 2": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Megane I": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999"
    ],
    "Megane I Facelift": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003"
    ],
    "Megane II": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Megane III": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "Megane IV": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Megane Scenic": [
      "1997",
      "1998",
      "1999"
    ],
    "Modus": [
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "Modus Facelift": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "Renault 4": [
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992"
    ],
    "Renault 5": [
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984"
    ],
    "Scenic I": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003"
    ],
    "Scenic II": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "Scenic III": [
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "Scenic III Facelift": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "Scenic IV": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Supercinque": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996"
    ],
    "Talisman": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Trafic II": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Trafic III": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Twingo I": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "Twingo II": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "Twingo II Facelift": [
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Twingo III": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Twizy": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Vel Satis": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "Wind": [
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "Zoe": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "Zoe Facelift": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ]
  },
  "Rover": {
    "25": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "45": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "75": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "200": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999"
    ],
    "400": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999"
    ],
    "Streetwise": [
      "2003",
      "2004",
      "2005"
    ]
  },
  "Saab": {
    "9-3 I": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003"
    ],
    "9-3 II": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008"
    ],
    "9-3 II Facelift": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "9-3X": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "9-5 I": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "9-5 I Facelift": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "9-5 II": [
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "9-7x": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ]
  },
  "Seat": {
    "Alhambra I": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000"
    ],
    "Alhambra I Facelift": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Alhambra II": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Altea": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "Altea XL": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "Arona": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021"
    ],
    "Arona Facelift": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Arosa": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001"
    ],
    "Arosa Facelift": [
      "2001",
      "2002",
      "2003",
      "2004"
    ],
    "Ateca": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021"
    ],
    "Ateca Facelift": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Cordoba I": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000"
    ],
    "Cordoba I Facelift": [
      "2000",
      "2001",
      "2002"
    ],
    "Cordoba II": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "Exeo": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "Ibiza II-6K": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999"
    ],
    "Ibiza II-6K Facelift": [
      "1999",
      "2000",
      "2001",
      "2002"
    ],
    "Ibiza III-6L": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "Ibiza III-6L Facelift": [
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "Ibiza IV-6J": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "Ibiza IV-6J Facelift": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "Ibiza V-KJ": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Leon I": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "Leon II": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "Leon III": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "Leon IV": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Marbella": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998"
    ],
    "Mii - Mii Electric": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Tarraco": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Toledo I": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998"
    ],
    "Toledo II": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004"
    ],
    "Toledo III": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "Toledo IV": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ]
  },
  "Skoda": {
    "Citigo": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Enyaq": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Fabia I-6Y": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "Fabia II-5J": [
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Fabia II-5J Facelift": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Fabia III-NJ": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Fabia III-NJ Facelift": [
      "2019",
      "2020",
      "2021"
    ],
    "Fabia IV": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Kamiq": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Karoq": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021"
    ],
    "Karoq Facelift": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Kodiaq": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021"
    ],
    "Kodiaq Facelift": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Octavia I": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004"
    ],
    "Octavia II": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008"
    ],
    "Octavia II Facelift": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "Octavia III": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "Octavia III Facelift": [
      "2017",
      "2018",
      "2019",
      "2020"
    ],
    "Octavia IV": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Rapid": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Rapid Facelift": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Roomster": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "Scala": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Superb I": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008"
    ],
    "Superb II": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "Superb II Facelift": [
      "2013",
      "2014",
      "2015"
    ],
    "Superb III": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "Superb III Facelift": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Yeti": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "Yeti Facelift": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017"
    ]
  },
  "Smart": {
    "Crossblade": [
      "2002",
      "2003"
    ],
    "Forfour W453": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "ForFour W453 Facelift": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Forfour W454": [
      "2004",
      "2005",
      "2006"
    ],
    "Fortwo W450": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002"
    ],
    "Fortwo W450 Facelift": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "Fortwo W451": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Fortwo W453": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "Fortwo W453 Facelift": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Roadster": [
      "2003",
      "2004",
      "2005"
    ]
  },
  "SsangYong": {
    "Actyon": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "Actyon II": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Korando II": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "Korando III": [
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "Korando III Facelift 1": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "Korando III Facelift 2": [
      "2017",
      "2018",
      "2019"
    ],
    "Korando IV": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Kyron D100": [
      "2005",
      "2006",
      "2007"
    ],
    "Kyron D200": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Musso": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Rexton Facelift Y250": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "Rexton Facelift Y300": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "Rexton II Y400": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021"
    ],
    "Rexton II Y400 Facelift": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Rexton Y200": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "Tivoli Facelift X150": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Tivoli X100": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "XLV": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ]
  },
  "Subaru": {
    "BRZ": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "BRZ Facelift": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020"
    ],
    "Forester I": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002"
    ],
    "Forester II": [
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "Forester II Facelift": [
      "2005",
      "2006",
      "2007"
    ],
    "Forester III": [
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "Forester IV": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Forester V": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Impreza I": [
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001"
    ],
    "Impreza II": [
      "2001",
      "2002",
      "2003"
    ],
    "Impreza II 1 Facelift": [
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "Impreza II 2 Facelift": [
      "2006",
      "2007"
    ],
    "Impreza III": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "Impreza IV": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "Impreza V": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Justy III": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "Justy IV": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Legacy IV": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "Legacy V": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "Legacy VI": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Levorg": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Outback III": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "Outback IV": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Outback V": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021"
    ],
    "Outback VI": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Solterra": [
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "XV I": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "XV II": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021"
    ],
    "XV II Facelift": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ]
  },
  "Suzuki": {
    "Across": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Alto IV-V": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003"
    ],
    "Alto VI": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "Alto VII": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Baleno": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Celerio": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Grand Vitara I": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "Grand Vitara II": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "Ignis I": [
      "2000",
      "2001",
      "2002",
      "2003"
    ],
    "Ignis II": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008"
    ],
    "Ignis III": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Jimny II": [
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998"
    ],
    "Jimny III": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Jimny IV": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Liana": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "Nuova Vitara": [
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Nuova Vitara Facelift": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Samurai": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003"
    ],
    "SJ-Santana": [
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989"
    ],
    "Splash": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "Swace": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Swift IV": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Swift V": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "Swift VI": [
      "2017",
      "2018",
      "2019",
      "2020"
    ],
    "Swift VI Facelift": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "SX4 Classic": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "SX4 S-Cross": [
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "SX4 S-Cross Facelift": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Vitara": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998"
    ],
    "Wagon R": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008"
    ]
  },
  "Tesla": {
    "Model 3": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Model S": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "Model S Facelift": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Model X": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Model Y": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Roadster": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ]
  },
  "Toyota": {
    "Auris E150": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "Auris E180": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Avensis II": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "Avensis III": [
      "2009",
      "2010",
      "2011"
    ],
    "Avensis III Facelift": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "Avensis III Facelift 2": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Avensis Verso": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "Aygo I": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Aygo II": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Aygo II Facelift": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Aygo X": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "bZ4X": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "C-HR I": [
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "C-HR II": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Celica V-T180": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993"
    ],
    "Celica VI-T200": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999"
    ],
    "Celica VII-T230": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "Corolla E120-E130": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "Corolla E140-E150": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "Corolla E160-E170": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Corolla E210": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "FJ Cruiser": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "GR86": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "GT86": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "GT86 Facelift": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020"
    ],
    "Highlander": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Hilux VI": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "Hilux VII": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "Hilux VIII": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020"
    ],
    "Hilux VIII Facelift": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "iQ": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "Land Cruiser 90-95": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002"
    ],
    "Land Cruiser 100": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "Land Cruiser 120-125": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008"
    ],
    "Land Cruiser 150-155": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Land Cruiser BJ20-30-40-50-60-70": [
      "1955",
      "1956",
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990"
    ],
    "Land Cruiser V8 200": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "MR2 W10": [
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989"
    ],
    "MR2 W20": [
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999"
    ],
    "MR2 W30": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003"
    ],
    "MR2 W30 Facelift": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "Picnic": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001"
    ],
    "Prius II": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "Prius III": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "Prius IV": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Proace I": [
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "Proace II - Verso - Crosscamp": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Rav4 I": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000"
    ],
    "Rav4 II": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "Rav4 III": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Rav4 III Facelift": [
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "Rav4 IV": [
      "2013",
      "2014",
      "2015"
    ],
    "Rav4 IV Facelift": [
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Rav4 V": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Supra III": [
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992"
    ],
    "Supra IV": [
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002"
    ],
    "Urban Cruiser": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Verso": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "Verso Facelift": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Verso S": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "Yaris Cross": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Yaris XP10": [
      "1999",
      "2000",
      "2001",
      "2002",
      "2003"
    ],
    "Yaris XP10 Facelift": [
      "2003",
      "2004",
      "2005"
    ],
    "Yaris XP90": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "Yaris XP130": [
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Yaris XP130 Facelift I": [
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "Yaris XP130 Facelift II": [
      "2017",
      "2018",
      "2019",
      "2020"
    ],
    "Yaris XP210": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ]
  },
  "Volkswagen": {
    "Amarok": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "Amarok Facelift": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Arteon": [
      "2017",
      "2018",
      "2019",
      "2020"
    ],
    "Arteon Facelift": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Bora": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "Caddy III": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Caddy III Facelift 1": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "Caddy III Facelift 2": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020"
    ],
    "Caddy IV": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "CC": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "Corrado": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995"
    ],
    "Crafter I": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "Crafter II": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Eos": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Eos Facelift": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "Fox": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "Golf I": [
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983"
    ],
    "Golf II": [
      "1983",
      "1984",
      "1985",
      "1986",
      "1987"
    ],
    "Golf II Facelift": [
      "1987",
      "1988",
      "1989"
    ],
    "Golf II Restiling 2": [
      "1989",
      "1990",
      "1991",
      "1992"
    ],
    "Golf III": [
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997"
    ],
    "Golf IV": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "Golf Sportsvan": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Golf V": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "Golf V Plus": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Golf VI": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "Golf VII": [
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "Golf VII Facelift": [
      "2017",
      "2018",
      "2019"
    ],
    "Golf VIII": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "ID.3": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "ID.4": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "ID.5": [
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "ID.Buzz": [
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Jetta A5": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Jetta A6": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Karmann Ghia": [
      "1955",
      "1956",
      "1957",
      "1958",
      "1959",
      "1960",
      "1961",
      "1962",
      "1963",
      "1964",
      "1965",
      "1966",
      "1967",
      "1968",
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974"
    ],
    "Lupo": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "Maggiolino": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "Multivan T7": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "New Beetle": [
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "Passat B3": [
      "1988",
      "1989",
      "1990",
      "1991",
      "1992",
      "1993"
    ],
    "Passat B4": [
      "1994",
      "1995",
      "1996",
      "1997"
    ],
    "Passat B5": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001"
    ],
    "Passat B5 Facelift": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "Passat B6": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Passat B7": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "Passat B8": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Passat CC": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "Pescaccia Tipo 181": [
      "1969",
      "1970",
      "1971",
      "1972",
      "1973",
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981",
      "1982",
      "1983"
    ],
    "Phaeton": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "Phaeton Facelift": [
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Phaeton Facelift II": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "Polo III 6N": [
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999"
    ],
    "Polo III 6N Facelift": [
      "1999",
      "2000",
      "2001",
      "2002"
    ],
    "Polo IV 9N": [
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "Polo IV 9N3 Facelift": [
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "Polo V 6C Facelift": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Polo V 6R": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Polo VI AW1": [
      "2018",
      "2019",
      "2020",
      "2021"
    ],
    "Polo VI AW1 Facelift": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Scirocco I": [
      "1974",
      "1975",
      "1976",
      "1977",
      "1978",
      "1979",
      "1980",
      "1981"
    ],
    "Scirocco II": [
      "1981",
      "1982",
      "1983",
      "1984",
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990",
      "1991",
      "1992"
    ],
    "Scirocco III": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Scirocco III Facelift": [
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "Sharan 7M": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000"
    ],
    "Sharan 7M Facelift I-II": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Sharan 7N": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "Sharan 7N Facelift": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "T-Cross": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "T-Roc": [
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022"
    ],
    "T-Roc Facelift": [
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Taigo": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Tiguan I": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011"
    ],
    "Tiguan I Facelift": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "Tiguan II": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020"
    ],
    "Tiguan II Facelift": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Touareg 7L": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "Touareg 7L Facelift": [
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Touareg II 7P": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "Touareg II 7P Facelift": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "Touareg III": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Touran": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "Touran 2 Facelift": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "Touran Facelift": [
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Touran II": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "Transporter T3 Facelift": [
      "1985",
      "1986",
      "1987",
      "1988",
      "1989",
      "1990"
    ],
    "Transporter T4": [
      "1990",
      "1991",
      "1992",
      "1993",
      "1994",
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003"
    ],
    "Transporter T5": [
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010"
    ],
    "Transporter T5 Facelift": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015"
    ],
    "Transporter T6": [
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "Transporter T6 Facelift": [
      "2019",
      "2020",
      "2021"
    ],
    "Transporter T25-T3": [
      "1979",
      "1980",
      "1981",
      "1982",
      "1983",
      "1984",
      "1985"
    ],
    "Up": [
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "Up Facelift": [
      "2016",
      "2017",
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ]
  },
  "Volvo": {
    "C30": [
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "C30 Facelift": [
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "C40": [
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "C70 I": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005"
    ],
    "C70 II": [
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "C70 II Facelift": [
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "S40 I": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004"
    ],
    "S40 II": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "S60 I": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009"
    ],
    "S60 II": [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "S60 III": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "S70": [
      "1997",
      "1998",
      "1999",
      "2000"
    ],
    "S80 I": [
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006"
    ],
    "S80 II": [
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "S90": [
      "2017",
      "2018",
      "2019",
      "2020"
    ],
    "S90 Facelift": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "V40": [
      "1995",
      "1996",
      "1997",
      "1998",
      "1999",
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "V40 Facelift": [
      "2016",
      "2017",
      "2018",
      "2019"
    ],
    "V50": [
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012"
    ],
    "V60 I": [
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "V60 I restyling": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018"
    ],
    "V60 II": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "V70 I": [
      "1996",
      "1997",
      "1998",
      "1999",
      "2000"
    ],
    "V70 II": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "V70 III": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "V90": [
      "2017",
      "2018",
      "2019",
      "2020"
    ],
    "V90 Facelift": [
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "X90 II Facelift": [
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "XC40": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022"
    ],
    "XC40 Facelift": [
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "XC60 I": [
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013"
    ],
    "XC60 I Facelift": [
      "2013",
      "2014",
      "2015",
      "2016",
      "2017"
    ],
    "XC60 II": [
      "2018",
      "2019",
      "2020",
      "2021",
      "2022",
      "2023",
      "2024",
      "2025",
      "2026"
    ],
    "XC70 II": [
      "2000",
      "2001",
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007"
    ],
    "XC70 III": [
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016"
    ],
    "XC90 I": [
      "2002",
      "2003",
      "2004",
      "2005",
      "2006",
      "2007",
      "2008",
      "2009",
      "2010",
      "2011",
      "2012",
      "2013",
      "2014"
    ],
    "XC90 II": [
      "2015",
      "2016",
      "2017",
      "2018",
      "2019"
    ]
  }
};

let makeObject2 = makeObject;
let makeObject3 = makeObject;
